<template>
  <div class="index" vkshop-event-scope="courseIndex">
    <!-- 能点击的Banner -->
    <shop-banner :list="bannerList"></shop-banner>
    <div class="title-line container clearfix">
      <p class="title">课程包系列</p>
      <div class="sort">
        <template>排序：{{sortChecked.value}}</template>
        <!-- <template v-if="sortChecked.key">{{sortChecked.value}}</template> -->
        <!-- <img src="@/assets/images/index/arrow.svg" /> -->
        <img src="@/assets/images/index/arrow.svg" />
        <div class="sort-list">
          <p
            v-for="(item, index) in sortList"
            :key="item.key"
            @click="sortChange(item)"
            vkshop-event-name="sortChange"
            :vkshop-event-param="'key=' + item.key"
            vkshop-event-type="click"
          >
            <template v-if="!index">{{item.value}}</template>
            <template v-if="index">{{item.value}}</template>
          </p>
        </div>
      </div>
    </div>
    <div class="container package-list">
      <div class="course">
        <ul class="packs">
          <li
            class="pack-item"
            :class="{'mr-0': !((idx + 1) % 4) }"
            v-for="(item, idx) in coursePacks"
            :key="item.id"
          >
            <a
              :href="'detail/' + item.id"
              vkshop-event-name="toDetail"
              :vkshop-event-param="'id='+ item.id"
              vkshop-event-type="click"
              target="_blank"
            >
              <img :src="item.urls[0] +'?quality,80'" />
              <div class="pack-content">
                <div class="pack-name">{{item.goodsGroupName}}</div>
                <div class="pack-price">￥{{item.minPrice}}</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import shopBanner from "./component/shopBanner.vue";
export default {
  name: "index",
  data() {
    return {
      coursePacks: {},
      bannerList: [],
      sortList: [
        {
          key: 0,
          value: "默认"
        },
        {
          key: 1,
          value: "价格由高到低"
        },
        {
          key: 2,
          value: "价格由低到高"
        }
      ],
      sortChecked: {}
    };
  },
  created() {
    this.sortChecked = this.sortList[0];
    this.getShopGroupsList();
    this.getBanners();
  },
  components: {
    shopBanner
  },
  methods: {
    sortChange(item) {
      this.sortChecked = item;
      this.getShopGroupsList();
      // if (item.key) {

      // }
    },
    //获取banner
    getBanners() {
      this.axios({
        method: "get",
        url: "/mall/api/goodsGroup/banner/list",
        params: {
          channel: 1
        }
      }).then(res => {
        if (res.data.code == 200) {
          this.bannerList =
            res.data.data.length > 0
              ? res.data.data.filter(item => {
                  return item.state === 3;
                })
              : res.data.data;
        }
      });
    },
    getShopGroupsList() {
      this.axios({
        method: "get",
        url: "/mall/api/goodsGroup/list",
        params: {
          page: 1,
          length: 1000,
          sort: this.sortChecked.key,
          activityType: 0
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.coursePacks = res.data.data.goodsGroupList;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.index {
  min-height: 100%;
  .title-line {
    margin: 41px auto 24px auto;
    color: #333333;
    overflow: visible;
    padding: 0 30px;
    .title {
      font-size: 24px;
      line-height: 33px;
      float: left;
    }
    .sort {
      position: relative;
      font-size: 16px;
      line-height: 22px;
      float: right;
      cursor: pointer;
      img {
        display: inline-block;
        height: 6px;
        margin-left: 8px;
        margin-bottom: 3px;
      }
      .sort-list {
        display: none;
        position: absolute;
        bottom: -120px;
        min-width: 160px;
        right: -0px; //-32
        //min-height: 134px;
        box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.06),
          0px 15px 40px 0px rgba(0, 0, 0, 0.12);
        background-color: #fff;
        img {
          transform: rotate(180deg);
        }
        p {
          font-size: 16px;
          padding: 0 32px;
          height: 40px;
          line-height: 40px;
          // &:first-child {
          //   height: 54px;
          //   line-height: 54px;
          //   &:hover {
          //     background-color: #fff;
          //     color: #333;
          //   }
          // }
          &:hover {
            background-color: #f85415;
            color: #fff;
          }
        }
      }
      &:hover {
        .sort-list {
          display: block;
        }
      }
    }
  }
  .package-list {
    padding: 0 30px;
    .packs {
      .pack-item {
        background-color: #fff;
        box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.02),
          0px 15px 40px 0px rgba(0, 0, 0, 0.02);
        border-radius: 4px;
        display: inline-block;
        margin-right: 30px;
        margin-bottom: 40px;
        overflow: hidden;
        line-height: 0;
        width: 243px;
        transition: box-shadow 0.3s;
        &:hover {
          box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.06),
            0px 15px 40px 0px rgba(0, 0, 0, 0.12);
        }
        &.mr-0 {
          margin-right: 0;
        }
        img {
          height: 243px;
          width: 243px;
          font-size: 0;
          display: inline-block;
        }
        .pack-content {
          line-height: 1.4;
          padding: 14px 16px 22px;
          .pack-name {
            color: #333333;
            font-size: 16px;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            height: 44px;
          }
          .pack-totalHours {
            color: #999999;
            font-size: 12px;
            line-height: 17px;
            height: 34px;
          }
          .pack-price {
            margin-top: 14px;
            color: #f85415;
            font-size: 24px;
            line-height: 33px;
          }
        }
      }
    }
  }
}
</style>
